import React from 'react';

import { Box } from '@mui/material';

import { VerifierStaffWrapperClearVerifyAdmin } from 'src/components/verifier';
import {
  InviteVerifiersAdminsByVerifierAdminModal,
  InviteVerifiersStaffByCVAdminModal,
  VerifierStaffDetailsModal,
} from 'src/modals/verifierStaff';
import { TableDataProvider } from 'src/providers/TableDataProvider';
import { SxProp } from 'src/types/mui';

export const VerifierDetailStaffPageClearVerifyAdmin: React.FC = () => {
  return (
    <React.Fragment>
      <Box sx={containerStyles}>
        <TableDataProvider>
          <VerifierStaffWrapperClearVerifyAdmin />
        </TableDataProvider>
      </Box>

      <InviteVerifiersStaffByCVAdminModal />
      <InviteVerifiersAdminsByVerifierAdminModal />
      <VerifierStaffDetailsModal />
    </React.Fragment>
  );
};

const containerStyles: SxProp = {
  display: 'flex',
  flexGrow: 1,
  flexShrink: 1,
  flexBasic: '0%',
  flexDirection: 'column',
  height: '100%',
};
